import { Command, HttpMethod } from "~/extensions/api";
export class GetAccountCommand extends Command {
    constructor(userCd) {
        super(HttpMethod.Get, `account/admin/${userCd}`);
    }
}
